<template>
<div>
    <l-tracker v-if="tracker.tracker_type === 1" :tracker="tracker" :highlighted="highlighted" :selected="selected" :trackerStatus="trackerStatus" :infoActive="infoActive" :angle="angle"
      @mouseover="handleMouseOver" @mouseout="handleMouseOut" @click="handleClick" @contextmenu="handleContextMenu">
      <l-popup v-if="isMobile && infoActive">
        <tracker-info :tracker="tracker" :trackerStatus="trackerStatus"></tracker-info>
      </l-popup>
      <l-tooltip v-if="!isMobile && infoActive">
        <tracker-info :tracker="tracker" :trackerStatus="trackerStatus"></tracker-info>
      </l-tooltip>
    </l-tracker>
    
    <l-standalone-tracker v-else-if="tracker.tracker_type === 2" :tracker="tracker" :highlighted="highlighted" :selected="selected" :trackerStatus="trackerStatus" :infoActive="infoActive" :angle="angle"
      @mouseover="handleMouseOver" @mouseout="handleMouseOut" @click="handleClick" @contextmenu="handleContextMenu">
      <l-popup v-if="isMobile && infoActive">
        <tracker-info :tracker="tracker" :trackerStatus="trackerStatus"></tracker-info>
      </l-popup>
      <l-tooltip v-if="!isMobile && infoActive">
        <tracker-info :tracker="tracker" :trackerStatus="trackerStatus"></tracker-info>
      </l-tooltip>
    </l-standalone-tracker> 
    <context-menu :open="contextmenu.show" :xyPosition="contextmenu.pos">
      <ul>
        <li @click="handleAddToSelection">Add to Selection</li>
      </ul>
    </context-menu>
  </div>
</template>

<script>
import { LPopup, LTooltip } from 'vue2-leaflet';
import LTracker from './LTracker';
import LStandaloneTracker from './LStandaloneTracker';
import TrackerInfo from './TrackerInfo';
import ContextMenu from './ContextMenu';

export default {
  name: 'Tracker',
  components: {
    LTracker,
    LStandaloneTracker,
    LPopup, 
    LTooltip,
    TrackerInfo,
    ContextMenu
  },
  props: {
    tracker: {
      type: Object,
      required: true
    },
    highlighted: {
      type: Boolean,
      required: true
    },
    selected: {
      type: Boolean,
      required: true
    },
    trackerStatus: {
      type: Object,
      required: true
    },
    infoActive: {
      type: Boolean,
      default: false
    },
    angle: {
      type: Number,
      default: 0
    },
    contextmenu: {
      type: Object
    }
  },
  computed: {
    isMobile() {
      return this.$feature.mobile;
    }
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event.originalEvent.ctrlKey, this.tracker);
    },
    handleMouseOver() {
      this.$emit('mouseover', this.tracker);
    },
    handleMouseOut() {
      this.$emit('mouseout');
    },
    handleAddToSelection() {
      this.$emit('click', true, this.tracker);
    },
    handleContextMenu(e) {
      this.$emit('contextmenu', {origin: e, ...this.tracker});
    }
  }
};
</script>